export default "__VITE_ASSET__B4J9ZPL0__"